import { Injectable, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";

/**
 * The DestroyService has to be provided per component for its ngOnDestroy to be called when the component gets destroyed.
 *
 * @example
 * @Component({
 *   selector: "some-component",
 *   templateUrl: "./some.component.html",
 *   providers: [DestroyService]
 * })
 * export class SomeComponent {
 */
@Injectable()
export class DestroyService extends Observable<void> implements OnDestroy {
  private readonly life$ = new Subject<void>();

  constructor() {
    super((subscriber) => this.life$.subscribe(subscriber));
  }

  public ngOnDestroy(): void {
    this.life$.next();
    this.life$.complete();
  }
}
